import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { SentimentActionableCommentsCardComponent } from './sentiment-analysis-overview-home/actionable-comments-card/actionable-comments-card.component';
import { SentimentOverviewWidgetComponent } from './sentiment-analysis-overview-home/sentiment-overview-widget/sentiment-overview-widget.component';
import { SentimentThemeDistributionWidgetComponent } from './sentiment-analysis-overview-home/theme-distribution-widget/theme-distribution-widget.component';
import { SentimentSummaryGeneratorWidgetComponent } from './sentiment-analysis-summary-home/summary-generator-widget/summary-generator-widget.component';
import { SentimentDetailsKeyMetricsComponent } from './sentiment-analysis-details-home/details-key-metrics/details-key-metrics.component';
import { SentimentDetailsTopThemesComponent } from './sentiment-analysis-details-home/details-top-themes/details-top-themes.component';
import { SentimentDetailsTrendWidgetComponent } from './sentiment-analysis-details-home/details-trend-widget/details-trend-widget.component';
import { SentimentDetailsHeatmapWidgetComponent } from './sentiment-analysis-details-home/details-heatmap-widget/details-heatmap-widget.component';
import { SentimentDetailsThemeBreakupBarsComponent } from './sentiment-analysis-details-home/details-theme-breakup-bars/details-theme-breakup-bars.component';
import { SentimentDetailsSubthemeBreakupComponent } from './sentiment-analysis-details-home/details-subtheme-breakup/details-subtheme-breakup.component';
import { SentimentDetailsTrendCohortCardComponent } from './sentiment-analysis-details-home/details-trend-cohort-card/details-trend-cohort-card.component';
import { SentimentDetailsHeatmapAnalysisComponent } from './sentiment-analysis-details-home/details-heatmap-analysis/details-heatmap-analysis.component';
import { LtmsLoaderComponent } from '../ltms-loader/ltms-loader.component';

@NgModule({
  declarations: [
    SentimentActionableCommentsCardComponent,
    SentimentOverviewWidgetComponent,
    SentimentThemeDistributionWidgetComponent,
    SentimentSummaryGeneratorWidgetComponent,
    SentimentDetailsKeyMetricsComponent,
    SentimentDetailsTopThemesComponent,
    SentimentDetailsTrendWidgetComponent,
    SentimentDetailsHeatmapWidgetComponent,
    SentimentDetailsThemeBreakupBarsComponent,
    SentimentDetailsSubthemeBreakupComponent,
    SentimentDetailsTrendCohortCardComponent,
    SentimentDetailsHeatmapAnalysisComponent,
  ],
  imports: [CommonModule, FormsModule, RouterModule, LtmsLoaderComponent],
  exports: [
    SentimentActionableCommentsCardComponent,
    SentimentOverviewWidgetComponent,
    SentimentThemeDistributionWidgetComponent,
    SentimentSummaryGeneratorWidgetComponent,
    SentimentDetailsKeyMetricsComponent,
    SentimentDetailsTopThemesComponent,
    SentimentDetailsTrendWidgetComponent,
    SentimentDetailsHeatmapWidgetComponent,
    SentimentDetailsThemeBreakupBarsComponent,
    SentimentDetailsSubthemeBreakupComponent,
    SentimentDetailsTrendCohortCardComponent,
    SentimentDetailsHeatmapAnalysisComponent,
  ],
})
export class SentimentAnalysisModule {}
